import { render, staticRenderFns } from "./CompanionRightArrowCard.vue?vue&type=template&id=222da139&scoped=true&lang=pug&"
import script from "./CompanionRightArrowCard.vue?vue&type=script&lang=js&"
export * from "./CompanionRightArrowCard.vue?vue&type=script&lang=js&"
import style0 from "./CompanionRightArrowCard.vue?vue&type=style&index=0&id=222da139&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222da139",
  null
  
)

export default component.exports